class LocalStorageService {
  setKey(key, value) {
    try { localStorage.setItem(key, value); }
    catch (e) { console.warn("LocalStorage setKey failed:", key, e); }
  }

  getKey(key) {
    try { return localStorage.getItem(key); }
    catch (e) { console.warn("LocalStorage getKey failed:", key, e); return null; }
  }

  removeKey(key) {
    try { localStorage.removeItem(key); }
    catch (e) { console.warn("LocalStorage removeKey failed:", key, e); }
  }

  getAllKeys() {
    const keys = [];
    for (let i = 0; i < localStorage.length; i++) {
      keys.push(localStorage.key(i));
    }
    return keys;
  }

  clear() {
    this.getAllKeys().forEach((key) => this.removeKey(key));
  }
}

export const storage = new LocalStorageService();

export const authStorage = {
  getToken: () => storage.getKey("token") || storage.getKey("jwt_token") || storage.getKey("user_token"),
  setToken: (token) => storage.setKey("token", token),
  removeToken: () => { storage.removeKey("token"); storage.removeKey("jwt_token"); storage.removeKey("user_token"); },
  isLoggedIn: () => {
    const logged = storage.getKey("logged");
    return (logged === "true" || logged === "1") && !!authStorage.getToken();
  },
  setLoggedIn: (value) => storage.setKey("logged", value ? "true" : "false"),
  getUserId: () => storage.getKey("userId"),
  setUserId: (id) => storage.setKey("userId", id),
};

export const prefStorage = {
  getCurrency: () => storage.getKey("coin") || "INR",
  setCurrency: (coin) => storage.setKey("coin", coin),
  getLanguage: () => storage.getKey("lang") || "en",
  setLanguage: (lang) => storage.setKey("lang", lang),
};
